import _sfc_main from './UiDropdownMenu.vue2.js';
import normalizeComponent from '../../_virtual/_plugin-vue2_normalizer.js';

var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "fds-ui-dropdown-menu" }, [_vm._t("root", function() {
    return [_vm._t("button", function() {
      return [_c("button", { directives: [{ name: "click-outside", rawName: "v-click-outside", value: _setup.closeDialog, expression: "closeDialog" }], ref: "toggleButton", staticClass: "fds-ui-button fds-ui-button--text fds-ui-dropdown-menu__button", attrs: { "type": "button", "aria-haspopup": "true", "aria-expanded": _setup.isDialogOpen ? "true" : "false", "aria-label": _vm.buttonText ?? _setup.translate("uiDropdownMenu.buttonText") }, on: { "click": function($event) {
        $event.stopPropagation();
        return _setup.toggleDialog.apply(null, arguments);
      } } }, [_c("span", { staticClass: "fds-ui-icon fds-ui-icon--more-v" })])];
    }, null, { openDialog: _setup.openDialog, isDialogOpen: _setup.isDialogOpen, closeDialog: _setup.closeDialog, toggleDialog: _setup.toggleDialog }), _vm._t("dialog", function() {
      return [_c("ul", { directives: [{ name: "show", rawName: "v-show", value: _setup.isDialogOpen, expression: "isDialogOpen" }], staticClass: "fds-ui-dropdown-menu__dialog", attrs: { "role": "menu" } }, [_vm._t("dialog:content", null, null, { openDialog: _setup.openDialog, isDialogOpen: _setup.isDialogOpen, closeDialog: _setup.closeDialog, toggleDialog: _setup.toggleDialog })], 2)];
    }, null, { openDialog: _setup.openDialog, isDialogOpen: _setup.isDialogOpen, closeDialog: _setup.closeDialog, toggleDialog: _setup.toggleDialog })];
  }, null, { openDialog: _setup.openDialog, isDialogOpen: _setup.isDialogOpen, closeDialog: _setup.closeDialog, toggleDialog: _setup.toggleDialog })], 2);
};
var _sfc_staticRenderFns = [];
_sfc_render._withStripped = true;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
__component__.options.__file = "/home/ubuntu/actions-runner/_work/library/library/packages/library/src/components/ui-dropdown-menu/UiDropdownMenu.vue";
var UiDropdownMenu = __component__.exports;

export { UiDropdownMenu as default };
